/* dc-scarcity.js — escasez dinámica configurable con localStorage (defer) */
(() => {
  'use strict';
  const KEY = 'dc_scarcity_v3';
  const now = () => Date.now();

  const load = () => {
    let s = null;
    try { s = JSON.parse(localStorage.getItem(KEY)); } catch (e) {}
    // Reset diario: la marca de creación (ts) no se toca al decrementar, así caduca de verdad a las 24h.
    if (!s || typeof s !== 'object' || !s.byColor || (now() - s.ts) > 864e5) {
      s = { byColor: {}, ts: now() };
    }
    return s;
  };
  const save = (s) => { try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {} };

  class DCScarcity extends HTMLElement {
    connectedCallback() {
      const cfg = {
        stockInicial: parseInt(this.dataset.stockInit || '7', 10),
        stockMin: parseInt(this.dataset.stockMin || '2', 10),
        viewersMin: parseInt(this.dataset.viewersMin || '11', 10),
        viewersMax: parseInt(this.dataset.viewersMax || '38', 10),
        showViewers: this.dataset.showViewers !== 'false',
        showStock: this.dataset.showStock !== 'false',
      };
      const s = load();
      const viewersEl = this.querySelector('[data-viewers]');

      // Stock POR COLOR: cada variante muestra un número distinto (dinamismo) y su barra.
      // Sincroniza TODA la página (DC Escasez + DC CTA Final comparten el mismo número).
      let activeKey = 'default';
      let activeIndex = 0;

      const seedFor = (i) => Math.max(cfg.stockMin, Math.min(20, cfg.stockInicial - i * 2));
      const stockOf = () => {
        if (typeof s.byColor[activeKey] !== 'number' || s.byColor[activeKey] < cfg.stockMin) {
          s.byColor[activeKey] = seedFor(activeIndex);
        }
        return s.byColor[activeKey];
      };
      const renderStock = () => {
        const val = stockOf();
        document.querySelectorAll('[data-stock]').forEach((el) => { el.textContent = val; });
        document.querySelectorAll('[data-sold]').forEach((el) => { el.textContent = Math.max(0, 23 - val); });
        document.querySelectorAll('[data-stock-bar]').forEach((el) => { el.style.width = Math.min(100, (val / 20) * 100) + '%'; });
      };
      renderStock();

      // Al cambiar de color/variante: cambia el número y mueve la barra
      document.addEventListener('dc:color', (e) => {
        const d = (e && e.detail) || {};
        activeKey = d.name || 'default';
        activeIndex = typeof d.index === 'number' ? d.index : 0;
        renderStock();
      });

      if (cfg.showStock) {
        setInterval(() => {
          if (Math.random() < 0.55 && stockOf() > cfg.stockMin) {
            s.byColor[activeKey] = stockOf() - 1; save(s); renderStock();
          }
        }, 65000);
      }
      if (cfg.showViewers && viewersEl) {
        const rnd = () => cfg.viewersMin + Math.floor(Math.random() * (cfg.viewersMax - cfg.viewersMin + 1));
        viewersEl.textContent = rnd();
        setInterval(() => { viewersEl.textContent = rnd(); }, 6500);
      }
    }
  }

  class DCToasts extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enabled === 'false') return;
      let names = []; let cities = []; let products = [];
      try { names = JSON.parse(this.dataset.names || '[]'); cities = JSON.parse(this.dataset.cities || '[]'); products = JSON.parse(this.dataset.products || '[]'); } catch (e) {}
      if (!names.length) names = ['Laura', 'Andrea', 'Camila', 'Valentina', 'Daniela'];
      if (!cities.length) cities = ['Bogotá', 'Medellín', 'Cali', 'Barranquilla'];
      const tpl = this.querySelector('[data-toast-tpl]');
      if (!tpl) return;
      const pick = (a) => a[Math.floor(Math.random() * a.length)];
      const fire = () => {
        const node = tpl.content ? tpl.content.cloneNode(true) : tpl.cloneNode(true);
        const root = node.querySelector ? node.querySelector('[data-toast]') : node;
        if (root) {
          const name = pick(names);
          const nameEl = root.querySelector('[data-toast-name]');
          const iniEl = root.querySelector('[data-toast-ini]');
          const cityEl = root.querySelector('[data-toast-city]');
          const minEl = root.querySelector('[data-toast-min]');
          const prodEl = root.querySelector('[data-toast-prod]');
          if (nameEl) nameEl.textContent = name;
          if (iniEl) iniEl.textContent = (name.trim()[0] || '').toUpperCase();
          if (cityEl) cityEl.textContent = pick(cities);
          if (minEl) minEl.textContent = 2 + Math.floor(Math.random() * 40);
          if (prodEl && products.length) prodEl.textContent = pick(products);
        }
        this.appendChild(node);
        const el = this.lastElementChild;
        setTimeout(() => { if (el) el.remove(); }, 5200);
      };
      // Tiempos configurables desde el admin (segundos → ms)
      const interval = Math.max(2, parseFloat(this.dataset.interval || '16')) * 1000;
      const delay = Math.max(0, parseFloat(this.dataset.delay || '4')) * 1000;
      setInterval(fire, interval);
      setTimeout(fire, delay);
    }
  }

  customElements.define('dc-scarcity', DCScarcity);
  customElements.define('dc-toasts', DCToasts);
})();
